import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-rename-copy',
  templateUrl: './dialog-rename-copy.component.html',
  styleUrls: ['./dialog-rename-copy.component.scss']
})
export class DialogRenameCopyComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogRenameCopyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rootName: string; suffix: string }
  ) {}

  // DisplayName est limité à 100 caractères en base, racine comprise.
  get suffixMaxLength(): number {
    return Math.max(0, 100 - (this.data.rootName?.length || 0));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.data.suffix && this.data.suffix.trim()) {
      this.dialogRef.close(this.data.rootName + this.data.suffix);
    }
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.onSubmit();
  }
}
